module.exports = __webpack_public_path__ + "static/media/external-link-icon.d2a394bd.svg";